import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../config/settings'
import { actualizarDatosControlDeGrado } from '../../actions/calidad'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import { FORM_CONTROL_DE_GRADO } from '../../../../config/forms'
import ControlDeGradoView from '../../components/calidad/ControlDeGradoView'

function ControlDeGrado (props) {
  const { actualizarDatosControlDeGrado } = props

  useEffect(() => {
    actualizarDatosControlDeGrado(new Date(), new Date())
  }, [actualizarDatosControlDeGrado])

  const actualizarFechas = (fechaD, fechaH) => {
    actualizarDatosControlDeGrado(fechaD, fechaH)
  }

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <div className='container-entre-fechas'>
        <DatePicker
          selectRange
          locale='es'
          disabledFuture
          onDateChange={actualizarFechas}
          titulo='Seleccione las fechas'
          value='fechas'
        />
      </div>
      <ControlDeGradoView />
    </>
  )
}

const mapActionsToProps = {
  actualizarDatosControlDeGrado
}

const withReduxForm = reduxForm({
  form: FORM_CONTROL_DE_GRADO
})

const withRedux = connect(null, mapActionsToProps)
export default withRedux(withReduxForm(ControlDeGrado))
